/**
 * Menu de opções do monitoramento — padrão Experiência do cliente (Grip).
 */

import React, { useEffect, useRef, useState } from 'react';
import { FileDown, FileSpreadsheet, Grip, Image } from 'lucide-react';
import { BoardClickUpToolbarButton } from '../../board/toolbar/BoardClickUpToolbarButton';
import '../../experiencia-cliente/components/ExperienciaClienteDetalhesModal.css';

export function MonitoramentoActionsMenu({
  onExportPdf,
  onExportPng,
  onExportXlsx,
  exportDisabled = false,
  showXlsx = true
}) {
  const wrapRef = useRef(null);
  const [open, setOpen] = useState(false);
  const [exporting, setExporting] = useState(false);

  useEffect(() => {
    if (!open) return undefined;
    const onDoc = (e) => {
      if (wrapRef.current?.contains(e.target)) return;
      setOpen(false);
    };
    document.addEventListener('mousedown', onDoc, true);
    return () => document.removeEventListener('mousedown', onDoc, true);
  }, [open]);

  const runExport = async (fn) => {
    if (exporting || exportDisabled || !fn) return;
    setOpen(false);
    setExporting(true);
    try {
      await fn();
    } catch (_) {
      // falha silenciosa — mesmo padrão dos outros módulos
    } finally {
      setExporting(false);
    }
  };

  return (
    <div className="ec-actions-menu-wrap monitoramento-actions-menu-wrap" ref={wrapRef}>
      <BoardClickUpToolbarButton
        iconOnly
        icon={Grip}
        tooltip="Opções"
        onClick={() => setOpen((o) => !o)}
        disabled={exporting}
        isOpen={open}
        ariaLabel="Opções do monitoramento"
        iconClassName="board-clickup-toolbar-menu-icon"
        className="board-clickup-toolbar-menu-btn"
      />
      {open ? (
        <div className="ec-actions-menu" role="menu" aria-label="Opções do monitoramento">
          <button
            type="button"
            className="ec-actions-menu-item"
            role="menuitem"
            onClick={() => runExport(onExportPdf)}
            disabled={exportDisabled || exporting}
          >
            <FileDown size={16} strokeWidth={1.5} aria-hidden />
            Exportar para PDF
          </button>
          <button
            type="button"
            className="ec-actions-menu-item"
            role="menuitem"
            onClick={() => runExport(onExportPng)}
            disabled={exportDisabled || exporting}
          >
            <Image size={16} strokeWidth={1.5} aria-hidden />
            Exportar para PNG
          </button>
          {showXlsx ? (
            <button
              type="button"
              className="ec-actions-menu-item"
              role="menuitem"
              onClick={() => runExport(onExportXlsx)}
              disabled={exportDisabled || exporting}
            >
              <FileSpreadsheet size={16} strokeWidth={1.5} aria-hidden />
              Exportar XLSX
            </button>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
